import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  POST_GHI_CHU_CHO_VAY,
  DELETE_GHI_CHU_CHO_VAY,
} from "actions/GhiChuChoVay/actionTypes";
import {
  postGhiChuChoVayFailure,
  postGhiChuChoVaySuccess,
  deleteGhiChuChoVayFailure,
  deleteGhiChuChoVaySuccess,
} from "actions/GhiChuChoVay";
import GhiChuChoVayApi from "service/ghiChuChoVayApi";
import { pushNotification } from "utils/notifications";
import { showModalGhiChuChoVay } from "actions/GhiChuChoVay";
import { setLoadGhiChu } from "actions/GhiChuChoVay";

function* postGhiChuChoVay(action) {
  try {
    const response = yield call(GhiChuChoVayApi.add, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(postGhiChuChoVayFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(postGhiChuChoVaySuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        if (!action.dataPost.ChovayNoteID) yield put(showModalGhiChuChoVay());
        yield put(setLoadGhiChu());
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(postGhiChuChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(postGhiChuChoVayFailure());
  }
}
function* deleteGhiChuChoVay(action) {
  try {
    const response = yield call(
      GhiChuChoVayApi.delete,
      action.dataPost.choVayNoteId
    );
    if (response.ok) {
      if (response.data.Error) {
        yield put(deleteGhiChuChoVayFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(deleteGhiChuChoVaySuccess(response.data));
        yield put(setLoadGhiChu());
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(deleteGhiChuChoVayFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(deleteGhiChuChoVayFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(POST_GHI_CHU_CHO_VAY, postGhiChuChoVay);
  yield takeLatest(DELETE_GHI_CHU_CHO_VAY, deleteGhiChuChoVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
